<mat-table [dataSource]="angularMatData" multiTemplateDataRows style="width: 100%" #sort="matSort" matSort
  matSortDisableClear matSortActive="Name" matSortDirection="asc" aria-label="List View Details Table" tabindex="0">
  <ng-container matColumnDef="Select">
    <mat-header-cell *matHeaderCellDef style="max-width:60px;padding-left: 0px;">
      <span>
        <tyl-checkbox [(checked)]="listRow.listStudentsCheckAll" (change)="listStudentsCheckAllClick(listRow);"
          [disabled]="!listRow.IsSelectedForMassEmail"></tyl-checkbox>
      </span>
    </mat-header-cell>
    <mat-cell *matCellDef="let SLDetail" style="max-width:60px;padding-left: 0px;">
      <tyl-checkbox [(checked)]="SLDetail.SelectedLists[listRow.ID]" (change)="listStudentClick(SLDetail, listRow);"
        [disabled]="!listRow.IsSelectedForMassEmail"></tyl-checkbox>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="StudentNumber">
    <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:150px;">
      <span translate>Student #</span>
    </mat-header-cell>
    <mat-cell *matCellDef="let SLDetail" style="max-width:150px;">{{SLDetail.StudentNumber}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="Name">
    <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:200px;">
      <span translate>Name</span>
    </mat-header-cell>
    <mat-cell *matCellDef="let SLDetail" style="max-width:200px;">{{SLDetail.Name}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="GradeLevel">
    <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width:150px;">
      <span translate>Grade Level</span>
    </mat-header-cell>
    <mat-cell *matCellDef="let SLDetail" style="max-width:150px;">{{SLDetail.GradeLevel}}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="Email">
    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:200px;">
      <span translate>Email Address</span>
    </mat-header-cell>
    <mat-cell [ngStyle]="{'background-color': (SLDetail.Email == '' || SLDetail.Email == null) ? '#ffff99' : 'none'}"
      *matCellDef="let SLDetail" style="min-width:200px;">{{SLDetail.Email}}</mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="columnsToDisplayInDetailListView"></mat-header-row>
  <mat-row *matRowDef="let row; columns: columnsToDisplayInDetailListView;" style="overflow: hidden;" tabindex="0"
    [attr.aria-label]="getAriaDetailRow(row)">
  </mat-row>
</mat-table>